/**
 * 「变更识别」行上对比类型 → 报告链接文案的单一来源。
 *
 * BcrSubTaskList 与 BcrReportLinks 两处都要渲染这批链接。此前两边各自
 * 复制了一份键列表和文案模板，结果 SOC_BSP 的过滤规则被分别加了两次；
 * 抽到这里避免再次漂移。
 */

/** 对比类型 → 报告链接文案。未列出的类型走 `${type}变更报告` 兜底。 */
const COMPARISON_REPORT_LABELS: Record<string, string> = {
  // 包内 SOC 镜像的文件级差异扫描。区别于 SOC 测试采集实机底软指纹产出的
  // 「SOC底软对比报告」——两者会并排显示在「变更识别」行，名字不能混。
  SOC_BSP: 'SOC镜像扫描报告',
};

/**
 * 子任务 result 里表示「这是多类型对比结果 dict」的键。
 * 与 bsp_back apps/bcr/serializers.py:60 的 choices 对齐。
 */
export const COMPARISON_RESULT_KEYS = ['MCU', 'SOC_MW', 'SOC_BSP', 'MCU-GIT', 'MCU_COMMIT'];

export const getComparisonReportLabel = (type: string): string =>
  COMPARISON_REPORT_LABELS[type] ?? `${type}变更报告`;
